import React from 'react';
import { useSelector } from 'react-redux';
import { AlarmClock, Clock } from 'lucide-react';
import { ToneBadge } from '../../../components/ui/ToneBadge';
import { selectTasksNow } from '../../../features/operatorTasks/operatorTasksSlice';
import { taskTimeOf } from '../../../features/operatorTasks/operatorTasksUtils';

/**
 * How a task stands in time: its deadline when it has one («Vence en 1 h 20
 * min»), otherwise how long it has waited («Esperando hace 3 h»). Always in
 * words, the colour only backs them up. It moves with the local clock,
 * corrected to the server's.
 *
 * @param {object} props
 * @param {{due_at?: string|null, waiting_since?: string|null}} props.task - A tray task or a queue row.
 */
export const TaskTimeChip = ({ task }) => {
  const now = useSelector(selectTasksNow);
  const time = taskTimeOf(task, now);
  if (!time) return null;

  return (
    <span data-testid="task-time-chip" data-kind={time.kind} className="inline-flex">
      <ToneBadge tone={time.tone} icon={time.kind === 'due' ? AlarmClock : Clock}>
        {time.text}
      </ToneBadge>
    </span>
  );
};
